import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPLIER_STATUS_FILTER_CATEGORIES } from 'src/constants/manageSuppliers';
import { SuppliersContext } from 'src/sections/manage_suppliers/SuppliersContext';
import { DropDownCategories } from 'src/types/generic';
import { useContextSelector } from 'use-context-selector';

const StatusFilterDropdown = () => {
  const { t } = useTranslation();
  const statusFilter = useContextSelector(SuppliersContext, (ctx) => ctx.statusFilter);
  const setStatusFilter = useContextSelector(SuppliersContext, (ctx) => ctx.setStatusFilter);

  const translatedFilterCategories = useMemo(
    () => SUPPLIER_STATUS_FILTER_CATEGORIES.map((cat) => ({ ...cat, label: t(cat.label) })),
    [t]
  );

  const translatedValue = useMemo(
    () => (statusFilter ? { ...statusFilter, label: t(statusFilter.label) } : null),
    [statusFilter, t]
  );

  const handleStatusFilterChange = useCallback(
    (e: DropDownListChangeEvent) => {
      setStatusFilter(e.value as DropDownCategories);
    },
    [setStatusFilter]
  );

  return (
    <DropDownList
      id="manage-supplier-status-filter"
      className="k-picker-solid product-filter-dropdown"
      style={{ width: 200 }}
      data={translatedFilterCategories}
      textField="label"
      dataItemKey="value"
      value={translatedValue}
      onChange={handleStatusFilterChange}
      popupSettings={{ className: 'toolbar-dropdown-popup' }}
    />
  );
};

export default StatusFilterDropdown;
